export default function SancionadosAdministrativamente() {        
    const hoje = new Date();
    const dataFormatada = hoje.toLocaleDateString('pt-BR');

    return (
        <div className="container mt-4">
            <p><small>Você está em <a href="/prestacao-de-contas">Prestação de Contas</a> / Licitantes ou Contratados Sancionados Administrativamente</small></p>
            <h1 className="mb-4">Licitantes ou Contratados Sancionados Administrativamente</h1>
            <p>2022 – Não há registro de licitantes ou contratados sancionados administrativamente pela ALEPE.</p>
            <p>2023 – Não há registro de licitantes ou contratados sancionados administrativamente pela ALEPE.</p>
            <p>2024 – Não há registro de licitantes ou contratados sancionados administrativamente pela ALEPE.</p>
            <p>2025 - Até o momento ({dataFormatada}), não há registro de licitantes ou contratados sancionados administrativamente pela ALEPE.</p>
        </div>
    );
}
